import axios from "axios";

const API_URL =
  (import.meta.env.VITE_API_URL || "http://localhost:4001") + "/api";

const getAuthHeaders = () => {
  const token = localStorage.getItem("admin_token");
  return {
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
    },
  };
};

export const adminService = {
  async login(credentials: { email: string; password: string }) {
    const res = await axios.post(`${API_URL}/auth/login`, credentials);
    return res.data;
  },

  async getCategoriesAdmin() {
    const res = await axios.get(
      `${API_URL}/categories/admin/all`,
      getAuthHeaders(),
    );
    return res.data;
  },

  async createCategory(data: { name: string }) {
    const res = await axios.post(
      `${API_URL}/categories`,
      data,
      getAuthHeaders(),
    );
    return res.data;
  },

  async updateCategory(id: string, formData: FormData) {
    const res = await axios.patch(
      `${API_URL}/categories/admin/${id}`,
      formData,
      {
        ...getAuthHeaders(),
        headers: {
          ...getAuthHeaders().headers,
          "Content-Type": "multipart/form-data",
        },
      },
    );
    return res.data;
  },

  async deleteCategory(id: string) {
    const res = await axios.delete(
      `${API_URL}/categories/admin/${id}`,
      getAuthHeaders(),
    );
    return res.data;
  },

  async getProducts() {
    const res = await axios.get(`${API_URL}/products`);
    return res.data;
  },

  async createProduct(formData: FormData) {
    const res = await axios.post(`${API_URL}/products/admin`, formData, {
      ...getAuthHeaders(),
      headers: {
        ...getAuthHeaders().headers,
        "Content-Type": "multipart/form-data",
      },
    });
    return res.data;
  },

  async updateProduct(id: string, formData: FormData) {
    const res = await axios.patch(`${API_URL}/products/admin/${id}`, formData, {
      ...getAuthHeaders(),
      headers: {
        ...getAuthHeaders().headers,
        "Content-Type": "multipart/form-data",
      },
    });
    return res.data;
  },

  async deleteProduct(id: string) {
    const res = await axios.delete(
      `${API_URL}/products/admin/${id}`,
      getAuthHeaders(),
    );
    return res.data;
  },

  async getContacts() {
    const res = await axios.get(
      `${API_URL}/contacts/admin/all`,
      getAuthHeaders(),
    );
    return res.data;
  },

  async updateContactStatus(id: string, isResolved: boolean) {
    const res = await axios.patch(
      `${API_URL}/contacts/${id}/status`,
      { isResolved },
      getAuthHeaders(),
    );
    return res.data;
  },

  async deleteContact(id: string) {
    const res = await axios.delete(
      `${API_URL}/contacts/${id}`,
      getAuthHeaders(),
    );
    return res.data;
  },
};
